export default __webpack_public_path__ + "static/media/az.acf7a85a.svg";